import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, Calendar, Check } from 'lucide-react';
interface MonthSelectorProps {
  selectedMonth: string;
  onMonthChange: (month: string) => void;
}
const months = ['September 2023', 'October 2023', 'November 2023', 'December 2023'];
export function MonthSelector({
  selectedMonth,
  onMonthChange
}: MonthSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <div className="relative inline-block text-left" ref={dropdownRef} data-id="element-116">
      

      {isOpen && <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 focus:outline-none animate-in fade-in zoom-in-95 duration-100" data-id="element-117">
          <div className="py-1" role="menu" aria-orientation="vertical" data-id="element-118">
            {months.map(month => <button key={month} onClick={() => {
          onMonthChange(month);
          setIsOpen(false);
        }} className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between hover:bg-slate-50 transition-colors ${selectedMonth === month ? 'bg-blue-50 text-blue-700 font-medium' : 'text-slate-700'}`} role="menuitem" data-id="element-119">
                {month}
                {selectedMonth === month && <Check className="w-3.5 h-3.5 text-blue-600" data-id="element-120" />}
              </button>)}
          </div>
        </div>}
    </div>;
}